/**
 * One place that knows how to open the settings-style dialogs, so the nav menu and
 * anything else that links a user into a settings screen (feature tips, empty states,
 * contextual hints) stay in step.
 */
app.factory("SettingsDialog", [
	"$mdDialog",
	"$rootScope",
	function ($mdDialog, $rootScope) {
		function show(config) {
			const scope = $rootScope.$new(true);
			const shown = $mdDialog.show(
				angular.extend(
					{
						parent: angular.element(document.body),
						clickOutsideToClose: false,
						openFrom: "#anchor",
						closeTo: "#anchor",
						scope: scope,
						preserveScope: false,
					},
					config
				)
			);
			// With preserveScope: true $mdDialog never destroys the scope, so the dialog
			// controller's $destroy cleanup never ran and its watchers stayed on $rootScope.
			// The scope is private to this dialog, so drop it once the dialog has closed.
			shown.finally(function () {
				scope.$destroy();
			});
			return shown;
		}

		return {
			/**
			 * @param {string} [section] one of the keys in settingTabsController's nav groups:
			 *   profile | reminders | taskAutomation | premiumLensPrices | practice | staff | rolePermissions |
			 *   appointmentTypes | practiceLeave | taskLabels | lensDispensing.
			 *   Omit to land on the default section.
			 * @param {Object} [options] - { multiple: true } to open over another dialog, which stays open.
			 *   { focus: { userId } } opens the staff section on that person, and { focus: { role } } the role
			 *   permissions section on that role.
			 */
			openSettings: function (section, options) {
				return show({
					controller: "settingTabsController",
					templateUrl: "app/src/views/templates/modal.settings.tmpl.html",
					locals: { initialSection: section || null, initialFocus: (options && options.focus) || null },
					multiple: !!(options && options.multiple),
				});
			},

			// CatTrax admins only: the permissions audit log, full screen, laid out like Settings.
			openPermissionAuditLog: function () {
				return show({
					controller: ["$scope", "$mdDialog", function ($scope, $mdDialog) {
						$scope.close = function () {
							$mdDialog.hide();
						};
					}],
					templateUrl: "app/src/js/components/admin/permissionRefusalsDialog.tmpl.html",
				});
			},

			openPaymentSettings: function () {
				return show({
					controller: "paymentTransactionsController",
					templateUrl: "app/src/js/components/paymentTransactions/payment-transactions.tmpl.html",
					preserveScope: true,
				});
			},

			openAiAgentSettings: function () {
				return show({
					controller: "agentSettingController",
					templateUrl: "app/src/js/components/aiAgentSetting/agent-setting.tmpl.html",
					preserveScope: true,
					locals: { isTabsView: true, patientId: null },
				});
			},

			openPatientForms: function (locals) {
				return show({
					controller: "sendFormController",
					templateUrl: "app/src/js/components/preOp/sendForm/sendForm.tmpl.html",
					locals: locals || {},
				});
			},

			openCustomFormDashboard: function (locals) {
				return show({
					controller: "customFormDashboardController",
					templateUrl: "app/src/js/components/preOp/sendForm/customFormDashboard.tmpl.html",
					locals: locals || {},
				});
			},

			openInventory: function () {
				return show({
					controller: "inventoryDashboardController",
					templateUrl: "app/src/js/components/inventory/inventoryDashboard.tmpl.html",
				});
			},
		};
	},
]);
